import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tab button component for tab navigation
 */
const TabButton = ({ 
  children,
  active = false,
  onClick,
  className = '',
  disabled = false,
  icon,
  ...props 
}) => {
  const baseClasses = "px-4 py-2 text-sm font-medium transition-all duration-200 border-b-2 flex items-center gap-2";
  
  const activeClasses = active
    ? "text-purple-600 border-purple-600 bg-purple-50"
    : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300";

  const disabledClasses = disabled 
    ? "opacity-50 cursor-not-allowed" 
    : "cursor-pointer";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${activeClasses} ${disabledClasses} ${className}`}
      {...props}
    >
      {icon && <span className="w-4 h-4">{icon}</span>}
      {children}
    </button>
  );
};

TabButton.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node
};

export default TabButton;
